<style lang="less" scoped>
.main {
  //width: 1240px;
  height: calc(100vh - 185px);
  margin: 0px 20px;
  border-radius: 12px;
  //padding-right: 20px;
  overflow-x: hidden;
  display: flex;

  .left {
    flex: 20;
   // background: #fff;
    border-radius: 12px;

    .book-attainment {

      margin: 0 auto;

      //justify-content: center;
      // align-items: center;
      .loading {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(50%, 50%);
      }
    }

    .book-attainment-content {
      border-radius: @border-radius-base;
      background-color: @white;
      flex: 20;
      //margin: 10px 0 0 0;
      padding: 15px 30px 30px 30px;

      .back-Btn {
        display: inline-block;
        justify-content: left;
        align-items: center;
        cursor: pointer;
        font-size: 20px;
        color: #dbd1cd;
        font-family: "PingFangSC-Semibold";
        height: 30px;

        .back-Icon {
          height: 19px;
          position: relative;
          right: 10px;
        }
      }

      .back-Btn:hover {
        color: @primary-color;
      }

      .attament-content-title {
       // margin-left: 30px;
        height: 45px;
        width: 100%;
        text-align: left;
        line-height: 38px;
        color: #000000;
        font-size: 16px;
        font-weight: 900;
        // font-weight: normal;
      }

      .has-ep {
        width: 80px;
        height: 30px;
        text-align: center;
        line-height: 28px;
        background: @primary-color;
        border-radius: 2px;
        border: 1px solid @primary-color;
        color: #fff;
        margin-left: 20px;
        margin-top: 2px;
      }

      .attament-content-knowledge {
        display: flex;
        position: relative;
        width: 100%;
       // min-height: 60px;
        background-color: #f8f8f8;
        align-items: center;
        font-size: 16px;
        color: #000;
        font-weight: 400;
        border-radius: 8px;
        padding:20px 60px 20px 0px;


        .atament-content-knowledge-logo {
          cursor: pointer;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 20px;
        }

        span {
          padding-left: 20px;
          font-size: 16px;
        }
      }

      .attament-content-ability {
        font-size: 20px;
      }
    }

    .deleteKnowledge {
      // height: 100px;
      margin: 30px 0 0 0;
      background: #fff;
      margin-bottom: 50px;
      padding: 10px;
      border-radius: 8px;

      .deleteCont {
        flex: 24;
        border-radius: 12px;
        height: auto;

        .deleteTitle {
          text-align: left;
          color: #9d9292;
          font-size: 16px;
          margin-top: 30px;
          padding-left: 20px;
        }

        .del {
          padding: 0 20px;
          margin-top: 30px;

          .attament-content-knowledge {
            display: flex;
            position: relative;
            width: 100%;
           // height: 60px;
            background-color: #f8f8f8;
            align-items: center;
            font-size: 16px;
            border-radius: 8px;
            padding:20px 60px 20px 0px;

            .atament-content-knowledge-logo {
              width: 20px;
              height: 20px;
              position: absolute;
              right: 20px;
              cursor: pointer;
            }

            span {
              padding-left: 20px;
              font-size: 16px;
            }
          }
        }
      }

      .noDom {
        flex: 4;
        background: #f1f0f0;
        margin-left: 20px;
      }
    }

    .attament-content-knowledge1 {
      width: 100%;
      min-height: 60px;
      padding: 20px;
      background-color: #f8f8f8;
      align-items: center;
      font-size: 16px;
      border-radius: 8px;
      color: #000;
      white-space: pre-wrap;
    }
  }

  .right {
    flex: 4;
    margin-left: 20px;
    border-radius: 8px;

    .studentLook {
      flex: 4;
      height: 160px;
      background: #fff;
      border-radius: 12px;
      text-align: center;

      .order {
        width: 120px;
        height: 40px;
        border-radius: 8px;
        background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
        margin-top: 20px;
      }

      .studentView {
        width: 120px;
        height: 40px;
        border-radius: 8px;
        margin-top: 20px;
        background: #f8f8f8;
        color: #000;
        border: none;

        .logo {
          width: 20px;
          height: 20px;
          margin-top: -4px;
          margin-right: 8px;
          margin-left: -10px;
        }
      }
    }

    .history {
      height: 160px;
      margin-top: 30px;
      background: #fff;
      border-radius: 12px;
      text-align: center;

      .resources {
        width: 120px;
        height: 48px;
        margin-top: 20px;
        color: #22c190;
        font-size: 18px;
      }

      .classes {
        width: 120px;
        height: 48px;
        margin-top: 20px;
        color: @primary-color;
        font-size: 18px;
      }
    }
  }
}

.classNumber {
  min-height: 260px;

  .classTop {
    .classSelect {
      height: 40px;
      line-height: 40px;
    }
  }

  .classBot {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;

    .cancelButton {
      width: 180px;
    }

    .classSureButton {
      width: 180px;
      background: @primary-color;
      color: #fff;
      margin-left: 10px;
    }
  }

  // /deep/.ant-modal-close-x {
  //   display: none;
  // }
}

/deep/.ant-checkbox+span {
  font-size: 20px;
  color: #040506;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  padding-left: 20px;
}

.view {
  .book-attainment {
    background-color: #f1f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "gwc", "宋体", "SimSun", "新宋体", "NSimSun", "仿宋", "FangSong";

    .loading {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(50%, 50%);
    }
  }

  .book-attainment-content {
    border-radius: @border-radius-base;
    background-color: @white;
    width: 1100px;
    padding-bottom: 55px;

    .back-Btn {
      display: inline-block;
      justify-content: left;
      align-items: center;
      cursor: pointer;
      font-size: 20px;
      color: #999999;
      font-family: "PingFangSC-Semibold";
      height: 30px;

      .back-Icon {
        height: 19px;
        position: relative;
        right: 10px;
      }
    }

    .back-Btn:hover {
      color: @primary-color;
    }

    .attainment-body {
      justify-content: space-between;
      display: flex;

      .attainment-knowledge,
      .attainment-ability {
        background: #F8F8F8;
        border-radius: 8px;
        width: 100%;
        margin-top: 20px;
        padding: 20px 30px;
      }

      .attainment-knowledge {
        margin-right: 20px;
      }

      .attament-content-title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .attament-content-knowledge {
        display: flex;
        align-items: center;
        font-size: 16px;
        white-space: pre-wrap;

        .atament-content-knowledge-logo {
          width: 16px;
          height: 12px;
        }

        span {
          position: relative;
          left: 5px;
        }
      }

      .top {
        align-items: start;
      }

      .attament-content-ability {
        font-size: 18px;
      }
    }
  }
}
</style>

<template>
  <div class="main">
    <div class="left">
      <div class="book-attainment">
        <a-spin class="loading" v-show="loading" />
        <div class="book-attainment-content">
          <div class="flex-row">
             <div class="attament-content-title">核心知识</div>
             <span  @click="orderRelease" type="primary" class="has-ep">发布</span>
          </div>
          <p class="attament-content-knowledge" v-for="(item, index) in knowledges" :key="'index' + index">
            <span>{{ item.content }}</span>
            <img @click="delHidden(item.id)" class="atament-content-knowledge-logo" src="@/assets/image/22.png" />
          </p>
          <div v-if="!knowledges || knowledges.length === 0">
            <a-empty />
          </div>
          <div class="attament-content-title">关键能力</div>
          <p class="attament-content-knowledge" v-for="(item, index) in ability" :key="index">
             <span>{{ item.content }}</span>
             <img @click="delAbility(item.id)" class="atament-content-knowledge-logo" src="@/assets/image/22.png" />
           </p>
          <div v-if="!ability|| ability.length === 0">
            <a-empty />
          </div>
        </div>
        <div class="deleteKnowledge">
          <div class="deleteCont">
            <div class="deleteTitle">已经隐藏的核心知识</div>
            <div class="del">
              <p class="attament-content-knowledge" v-for="(item, index) in knowledgeDel" :key="index">
                <span>{{ item.content }}</span>
                <img @click="addHidden(item.id)" class="atament-content-knowledge-logo" src="@/assets/image/23.png" />
              </p>
              <div v-if="!knowledgeDel|| knowledgeDel.length === 0">
                <a-empty />
              </div>
            </div>
            <div class="deleteTitle">已经隐藏的关键能力</div>
            <div class="del">
              <p class="attament-content-knowledge" v-for="(item, index) in abilityDel" :key="index">
                <span>{{ item.content }}</span>
                <img @click="addAbility(item.id)" class="atament-content-knowledge-logo" src="@/assets/image/23.png" />
              </p>
              <div v-if="!abilityDel|| abilityDel.length === 0" style="margin-bottom: 20px">
                <a-empty />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="right">-->
<!--      <div class="studentLook">-->
<!--        <a-button class="order" type="primary" @click="orderRelease">发布</a-button>-->
<!--        <a-tooltip placement="top" :title="tipMess">-->
<!--          <a-button class="studentView" type="primary" @click="goStudent"><img class="logo"-->
<!--              src="@/assets/imgs/logo2.png" />学生端预览</a-button>-->
<!--        </a-tooltip>-->

<!--      </div>-->
<!--    </div>-->

    <div v-if="release">
      <a-modal class="classNumber" v-model="release" width="440px" title="" footer="">
        <div class="classTop">
          <a-checkbox-group @change="checkClass">
            <div class="classSelect" v-for="(item, index) in classData" :key="index">
              <a-checkbox :value="item.id">{{ item.className }}</a-checkbox>
            </div>
          </a-checkbox-group>
          <div class="classBot">
            <a-button class="cancelButton" @click="release = false">取消</a-button>
            <a-button class="classSureButton" @click="classSure">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <div v-if="lookVis">
      <a-modal class="classNumber" v-model="lookVis" width="440px" title="" footer="">
        <div class="classTop">
          <a-radio-group @change="lookCheckClass">
            <div class="classSelect" v-for="(item, index) in classData" :key="index">
              <a-radio :value="item.id">{{ item.className }}</a-radio>
            </div>
          </a-radio-group>
          <div class="classBot">
            <a-button class="cancelButton" @click="lookVis = false">取消</a-button>
            <a-button class="classSureButton" @click="lookSure">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <div v-if="look">
      <a-modal title="预览" class="classNumber" v-model="look" width="1100px" @cancel="() => { look = false }" footer="">
        <div class="view">
          <div class="book-attainment">
            <a-spin size="large" class="loading" v-show="loading" />
            <div class="book-attainment-content">
              <div class="attainment-body">
                <div class="attainment-knowledge">
                  <div class="attament-content-title">
                    <span>核心知识</span>
                  </div>
                  <p class="attament-content-knowledge" v-for="(knowledge, index) in lookKnowledges" :key="index">
                    <img src="../../assets/imgs/snails.png" alt="">
                    <span style="margin-left: 5px;">{{ knowledge }}</span>
                  </p>
                  <div v-if="!lookKnowledges || lookKnowledges.length === 0">
                    <a-empty />
                  </div>
                </div>
                <div class="attainment-ability">
                  <div class="attament-content-title">
                    <span>关键能力</span>
                  </div>
                  <p class="attament-content-knowledge top" v-for="(ability, aindex) in abilitys"
                    :key="`ability${aindex}`">
                    <template v-if="ability">
                      <span>{{ aindex+ 1}}.</span>
                      <span>{{ ability.trim() }}</span>
                    </template>
                  </p>
                  <div v-if="abilitys == null || abilitys.length === 0">
                    <a-empty style="margin-top:80px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-modal>
    </div>

  </div>

</template>

<script>
import HanIcon from 'components/Icon.vue'
export default {
  name: 'Attainment',
  components: { HanIcon },
  data () {
    return {
      knowledges: [],
      knowledgeDel: [],
      ability: [],
      abilityDel: [],
      loading: false,
      release: false,
      disabledClass: false,
      classData: [], // 班级信息列表
      orderParam: [], // 选择的发布班级
      look: false,
      lookKnowledges: [],
      abilitys: [],
      lookVis: false,
      lookClassData: '',
      tipMess: '请您发布成功后再预览！'
    }
  },
  watch: {
    $route () {
      // this.getAttainment()
    }
  },
  mounted () {
    this.getRecommandList()
    this.getClassNum()
    const isBookList = this.$store.state.myBookList.some(item => {
      return item.isBuy == 1
    })
    this.$store.commit('setIsBookBuy', isBookList)
  },
  methods: {
    lookSure () {
      if (this.lookClassData == '') {
        this.$message.warning('请选择要预览的班级')
      } else {
        const param = {
          styleId: localStorage.getItem('styleId'),
          userId: this.$getUserInfo().id,
          classId: this.lookClassData
        }
        this.$fetch({
          url: this.$baseUrl + 'ebook/teacher/keyPoint/getTeacherKeyPointPreview',
          body: param
        }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
        ).done(res => {
          if (res && res.success) {
            this.$nextTick(() => {
              this.lookVis = false
              this.lookKnowledges = res.resultData.keyKnowledgeShowList // 核心能力现实
              this.abilitys = res.resultData.keyAbilityShowList
              this.look = true
            })
          } else {
            this.$message.error(res.resultMessage)
          }
        })
      }
    },
    goStudent () {
      this.lookVis = true
    },
    classSure () {
      const param = {
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        classIds: this.orderParam
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/push/publishToClass',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('发布成功')
          this.release = false
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    checkClass (val) {
      this.orderParam = val
      if (this.orderParam.length > 0) {
        this.disabledClass = true
      } else {
        this.disabledClass = false
      }
    },
    lookCheckClass (val) {
      this.lookClassData = val.target.value
    },
    getClassNum () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/v3/common/getSimpleClaList',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode === '0') {
          this.classData = res.resultData
        }
      })
    },
    orderRelease () { // 发布
      if (this.classData != null && this.classData.length > 0) {
        this.release = true
      } else {
        this.$message.warning('暂无发布班级信息')
      }
    },
    getRecommandList () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/getTeacherKeyPoint',
        body: {
          styleId: localStorage.getItem('styleId')
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.knowledges = res.resultData.keyKnowledgeShow
        this.ability = res.resultData.keyAbilityShow
        this.knowledgeDel = res.resultData.keyKnowledgeHidden
        this.abilityDel = res.resultData.keyAbilityHidden
      })
    },
    // 隐藏单挑
    delHidden (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/deleteUserKeyKnowledge',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('隐藏成功')
        this.getRecommandList()
      })
    },
    // 显示隐藏
    addHidden (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/addUserKeyKnowledge',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('显示成功')
        this.getRecommandList()
      })
    },
    // 显示关键能力
    addAbility (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/addUserKeyAbility',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('显示成功')
        this.getRecommandList()
      })
    },
    // 隐藏关键能力
    delAbility (id) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/keyPoint/deleteUserKeyAbility',
        body: {
          styleId: localStorage.getItem('styleId'),
          id: id
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.$message.success('隐藏成功')
        this.getRecommandList()
      })
    },
  }
}
</script>
